import script from "./ProtocolGatewayDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtocolGatewayDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProtocolGatewayDetail.vue?vue&type=style&index=0&id=1f8a38e3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8a38e3"]])

export default __exports__